import React from 'react';
import twitterIcon from '../assets/site_assets/1 Twitter.png';
import instagramIcon from '../assets/site_assets/2 Instagram.png';
import blueskyIcon from '../assets/site_assets/3 Bluesky.png';
import patreonIcon from '../assets/site_assets/4 Patreon.png';
import globalComixIcon from '../assets/site_assets/5 GlobalComix.png';

const socialPlatforms = [
  {
    name: 'Twitter',
    href: 'https://x.com/SmappysIsland', 
    icon: twitterIcon
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/smappys_island/', 
    icon: instagramIcon
  },
  {
    name: 'Bluesky',
    href: 'https://bsky.app/profile/smappy.bsky.social', 
    icon: blueskyIcon
  },
  {
    name: 'Patreon',
    href: 'https://www.patreon.com/cw/smappy',
    icon: patreonIcon
  },
  {
    name: 'GlobalComix',
    href: 'https://globalcomix.com/a/smappysisland', 
    icon: globalComixIcon
  }
];

function SocialLinks() {
  return (
    <div className="social-links-container">
      <div className="social-links">
        {socialPlatforms.map(platform => (
          <a
            key={platform.name}
            className="social-link"
            href={platform.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={platform.name}
            title={platform.name}
          >
            <img src={platform.icon} alt={platform.name} className="social-icon" />
          </a>
        ))}
      </div>
    </div>
  );
}

export default SocialLinks;
